import { type EditorWidget } from 'mini-code'
import type React from 'react'
import {
  type PatternEventInfo,
} from '../bytecode.ts'

export class NoteWidget {
  private widgetKey: string
  private opacity = 0

  constructor(
    private event: PatternEventInfo,
    private activeNotesRef: React.RefObject<Map<string, number>>,
    private patternLengthsRef: React.RefObject<Map<number, number>>,
    private widgetOpacityRef?: React.RefObject<Map<string, number>>,
  ) {
    this.widgetKey = `${event.line}-${event.column}-${event.length}-${event.sequenceId ?? ''}-${event.noteIndex ?? ''}`
  }

  toEditorWidget(): EditorWidget {
    return {
      type: 'overlay',
      line: this.event.line,
      column: this.event.column,
      length: this.event.length,

      render: (ctx, x, y, width, height) => {
        if (this.widgetOpacityRef) {
          this.opacity = this.widgetOpacityRef.current.get(this.widgetKey) ?? 0
        }

        if (this.event.sequenceId !== undefined && this.event.noteIndex !== undefined) {
          const patternLengths = this.patternLengthsRef.current
          const patternLength = patternLengths.get(this.event.sequenceId)
          // Use noteIndex directly - pattern events already map to expanded sequence
          const activeKey = `${this.event.sequenceId}-${this.event.noteIndex}`
          const samplePosition = this.activeNotesRef.current.get(activeKey)

          if (samplePosition !== undefined) {
            this.opacity = 1
          }
          else {
            this.opacity *= 0.6
            if (this.opacity < 0.01) this.opacity = 0
          }

          if (this.widgetOpacityRef) {
            this.widgetOpacityRef.current.set(this.widgetKey, this.opacity)
          }
        }

        if (this.opacity) {
          ctx.strokeStyle = `rgba(100,100,250,${this.opacity ** .3})`
          ctx.lineWidth = 1
          ctx.strokeRect(x, y - 1, width, height)
        }
      },
    }
  }
}
